import api from '@/plugins/api';

export default class Language {
  constructor() {
    this.loading = false;
    this.$value = '';
    this.$data = {
      ru: new Map(),
    };
  }

  get value() {
    return this.$value;
  }

  set value(value) {
    if (!this.$data[value]) {
      this.$data[value] = new Map();
    }
    this.$value = value;
    this.download(value);
  }

  get data() {
    return this.$data[this.value] || new Map();
  }


  get(val) {
    const key = val?.key || val;
    const vars = val?.vars || {};
    const keys = Array.isArray(key) ? key : [key];
    return keys.reduce((s, i) => `${s}${this.data.get(i) || vars[i] || i}`, '');
  }

  set(value, map) {
    if (!this.$data[value]) {
      this.$data[value] = new Map();
    }
    map.forEach((val) => {
      this.$data[value].set(val[0], val[1]);
    });
  }

  download(key) {
    return new Promise((resolve) => {
      this.loading = true;
      const url = DEV
        ? `language/${key}.json`
        : `language/${key}.json`;
        // : `https://static.mag.travel/app/language/${key}.json`;
      api
        .get(url, { store: { key: `language/${key}` } })
        .then((data) => {
          this.set(key, data);
        })
        .finally(() => {
          this.loading = false;
          resolve();
        });
    });
  }
}
